<template lang="pug">
el-dialog(v-dialogDrag title="导入表格" append-to-body :visible.sync="uploaderExcelDialog" width="900px" :before-close="handleClose")
  .uploaderContent
    .nav
      el-steps(:active="active" process-status="finish" align-center)
        el-step(title="选择EXCEL表")
        el-step(title="数据预览")
        el-step(title="导入设置")
        el-step(title="导入数据")
    .list
      choiceUp(ref="choiceUp" :tableName="tableName" @uploaderInfo="uploaderInfo" v-if="active === 0")
      dataViewUp(ref="dataViewUp" :excelData="excelData" v-if="active === 1")
      importSet(ref="importSet" :excelData="excelData" :tableName="tableName" v-if="active === 2")
      lastUp(ref="lastUp" v-if="active === 3")
    .pages
      el-button(type="primary" plain @click="prev" v-if="active !== 0" size="small") 上一步
      el-button(type="primary" @click="next" v-if="active === 1" size="small") 下一步
      el-button(type="primary" @click="save" v-if="active === 2 " size="small") 导 入
      el-button(type="primary" @click="handleClose" v-if="active === 3 && responseData.success" size="small") 完成

</template>

<script>
import flowService from "@/CommonDP/service/flow-service";
import choiceUp from "./choiceUp.vue";
import dataViewUp from "./dataViewUp.vue";
import importSet from "./importSet.vue";
import lastUp from "./lastUp.vue";
export default {
  components: { choiceUp, dataViewUp, importSet, lastUp },
  props: {
    tableName: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      active: 0,
      excelData: [],
      responseData: "",
      uploaderExcelDialog: false
    };
  },
  methods: {
    open() {
      this.uploaderExcelDialog = true;
    },
    async uploaderInfo(val) {
      const { fileId } = val;
      await this.queryExcelData(fileId);
      this.active = 1;
    },
    async queryExcelData(fileId) {
      this.excelData = [];
      const res = await flowService.importDataRead(fileId);
      this.excelData = res.data;
    },
    save() {
      this.$confirm(`确定导入当前配置的数据`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const columnMappingList = this.$refs.importSet.getMappingList();
        const params = {
          columnMappingList,
          dataList: this.excelData,
          tableName: this.tableName
        };
        this.active = 3;
        await this.$nextTick();
        this.$refs.lastUp.startLoading();
        const res = await flowService.saveExcelData(params);
        this.responseData = res.data || "";
        this.$refs.lastUp.isSuccess(this.responseData);
        this.$emit("submit");
        // this.$success("操作成功");
      }).catch((error) => {
        console.log(error);
      });
    },
    handleClose() {
      // this.$emit("close");
      this.uploaderExcelDialog = false;
    },
    prev() {
      this.active--;
    },
    next() {
      this.active++;
    }
  }
};
</script>

<style lang="scss" scoped>
.uploaderContent{
  width: 100%;
  height: 500px;
  display: flex;
  flex-direction: column;
}
.list{
  padding:10px;
}
.pages{
  height: 50px;
  margin-top: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
/deep/.el-step__title{
  font-size: 14px;
}
</style>
